"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-spring-manufacturing";
const ICON_BASE = "/image/new-version/more/SpringManufacturing/图标";

const CAPABILITIES = [
	{ keyPrefix: "capabilitiesCard1", icon: "mass-production-mold-engineering.svg" },
	{ keyPrefix: "capabilitiesCard2", icon: "high-volume-precision-spring-coiling.svg" },
	{ keyPrefix: "capabilitiesCard3", icon: "consistent-end-finishing-for-bulk-orders.svg" },
	{ keyPrefix: "capabilitiesCard4", icon: "batch-surface-finishing-solutions.svg" },
	{ keyPrefix: "capabilitiesCard5", icon: "professional-fatigue-life-validation.svg" },
	{ keyPrefix: "capabilitiesCard6", icon: "high-volume-custom-shaped-spring-production.svg" },
	{ keyPrefix: "capabilitiesCard7", icon: "full-line-quality-control-for-mass-production.svg" },
	{ keyPrefix: "capabilitiesCard8", icon: "rapid-pilot-production-for-bulk-orders.svg" },
] as const;

export default function SpringManufacturingCapabilities() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#fcfff4] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("capabilitiesTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("capabilitiesDesc")}</p>
				</header>

				<div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
					{CAPABILITIES.map((item) => (
						<article
							key={item.keyPrefix}
							className="border-t-4 border-themePrimary400 bg-white px-5 py-8 text-center shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg sm:px-6 sm:py-10"
						>
							<div className="mx-auto mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-[#f2ffe2] sm:h-24 sm:w-24">
								<Image
									src={`${ICON_BASE}/${item.icon}`}
									alt={t(`${item.keyPrefix}ImageAlt`)}
									width={48}
									height={48}
									className="h-11 w-11 object-contain sm:h-12 sm:w-12"
								/>
							</div>
							<h3 className="mb-3 text-lg font-bold leading-snug text-black sm:text-xl">
								{t(`${item.keyPrefix}Title`)}
							</h3>
							<p className="text-sm leading-relaxed text-black">{t(`${item.keyPrefix}Desc`)}</p>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
